import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StudentPanelService } from './student-panel.service';

export interface ISummaryItem {
  icon: string;
  text: string;
}
@Component({
  selector: 'student-panel',
  template: require('./student-panel.component.html'),
  styles: [require('./student-panel.scss')],
})
export class StudentPanelComponent implements OnInit {
  @Input() panelTitle: any;
  @Input() collapsed: boolean;
  @Input() summaryItems: ISummaryItem[];
  @Output() collapsedPanelsUpdatedEvent: EventEmitter<any> = new EventEmitter();

  hasSummaryItems: boolean;

  constructor(private studentPanel: StudentPanelService) {}

  ngOnInit(): void {
    this.collapsed = this.studentPanel.getInitialPanelStateBasedOnHuman(this.panelTitle);
    this.hasSummaryItems = this.summaryItems && this.summaryItems.length > 0;
  }

  /**
   * Ideally, would be able to pass this.collapsed state as
   * binding through ng-content. But cant get that approach to work.
   * Instead, actual panel toggling code lives in a StudentPanelService that is injected into each component. This
   * method just determines icon state.
   */
  togglePanelIcon(): void {
    this.collapsed = !this.collapsed;
    this.collapsedPanelsUpdatedEvent.emit(null);
  }
}
